import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "mMenu",
  inject: ["reload"],
  computed: {
    ...walletVuex.mapState(["isMobile"])
  },
  data() {
    const menuList = [{
      label: "Biography",
      value: "biography"
    }, {
      label: "Rewards",
      value: "rewards"
    }, {
      label: "AI",
      value: "home"
    }, {
      label: "Membership",
      value: "membership"
    }, {
      label: "Share",
      value: "friends"
    }];
    return {
      menuList,
      selectMenu: null
    };
  },
  watch: {
    "$route.path": {
      handler(path) {
        if (path === "/") {
          return this.selectMenu = "home";
        }
        this.selectMenu = path.split("/")[1];
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onMenu(item) {
      this.hapticFeedback();
      if (item.value === "home") {
        this.selectMenu = "home";
        if (this.$route.path == "/") {
          this.reload();
        } else {
          this.$router.push(`/`);
        }
        return;
      }
      this.selectMenu = item.value;
      this.$router.push(`/${item.value}`);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.mMenusRef.addEventListener("touchmove", e => {
        e.preventDefault();
        e.stopPropagation();
      }, {
        passive: false
      });
    });
  }
};